import { FloatingList } from '@floating-ui/react'

import { SelectDropdown } from '../SelectDropdown'
import { SelectDropdownEmpty } from '../SelectDropdownEmpty'
import { SelectDropdownEntityListItem } from '../SelectDropdownEntityListItem'
import { SelectDropdownListContainer } from '../SelectDropdownListContainer'

import {
  showSelectDropdownListFooter,
  showSelectDropdownListHeader,
} from './SelectDropdownList.utils'

import * as styles from './SelectDropdownList.module.css'

function SelectDropdownList({
  Empty = SelectDropdownEmpty,
  Footer,
  Header,
  Item = SelectDropdownEntityListItem,
  ListContainer = SelectDropdownListContainer,
  className = styles.SelectDropdownList,
  disabled,
  elementsRef,
  emptyProps,
  footerProps,
  headerProps,
  itemProps,
  listContainerProps,
  options,
  showFooter = showSelectDropdownListFooter,
  showHeader = showSelectDropdownListHeader,
  ...restProps
}) {
  return (
    <SelectDropdown {...restProps} className={className}>
      {showHeader({ Header, options }) ? (
        <Header {...headerProps} disabled={disabled} />
      ) : null}

      {options?.length > 0 ? (
        <ListContainer {...listContainerProps}>
          <FloatingList elementsRef={elementsRef}>
            {options.map((option, index) =>
              option.Divider ? (
                <option.Divider key={option.value} />
              ) : (
                <Item
                  {...itemProps}
                  disabled={disabled || option.disabled}
                  key={option.value || index}
                  value={option}
                />
              )
            )}
          </FloatingList>
        </ListContainer>
      ) : (
        <Empty {...emptyProps} />
      )}

      {showFooter({ Footer, options }) ? (
        <Footer {...footerProps} disabled={disabled} />
      ) : null}
    </SelectDropdown>
  )
}

export default SelectDropdownList
